import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { LayoutDashboard, ShoppingCart, DollarSign, ScanSearch } from "lucide-react";
import { PriceCheckDialog } from "./CameraScanner";

const itemCls = (active) => `relative flex flex-col items-center justify-center gap-0.5 h-16 text-xs font-medium transition-colors ${active ? "text-slate-900" : "text-slate-500"}`;

export const MobileBottomBar = ({ expenseAlertCount, boxId, showPrice }) => {
  const location = useLocation();
  const [priceOpen, setPriceOpen] = useState(false);
  const items = [
    { to: "/", label: "Dashboard", icon: LayoutDashboard, id: "dashboard", active: location.pathname === "/" },
    { to: "/inventory?tab=vender", label: "Vender", icon: ShoppingCart, id: "sell", active: location.pathname === "/inventory", primary: true },
    { to: "/expenses", label: "Gastos", icon: DollarSign, id: "expenses", active: location.pathname === "/expenses", badge: expenseAlertCount },
  ];
  return (
    <>
      <nav
        data-testid="mobile-bottom-bar"
        className={`md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-xl border-t border-slate-200 grid ${showPrice ? "grid-cols-4" : "grid-cols-3"}`}
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      >
        {items.map(({ to, label, icon: Icon, id, active, primary, badge }) => (
          <Link key={id} to={to} data-testid={`mobile-bottom-${id}`} className={itemCls(active)}>
            <span className={`flex items-center justify-center rounded-full transition-transform active:scale-90 ${primary ? "w-11 h-11 -mt-5 bg-emerald-600 text-white shadow-lg border-4 border-white" : "w-8 h-8"} ${active && !primary ? "bg-slate-100" : ""}`}>
              <Icon className="w-5 h-5" />
            </span>
            {label}
            {badge > 0 && (
              <span className="absolute top-1.5 left-1/2 ml-2 min-w-[18px] h-[18px] px-1 rounded-full bg-red-600 text-white text-[10px] font-bold flex items-center justify-center">
                {badge > 99 ? "99+" : badge}
              </span>
            )}
          </Link>
        ))}
        {showPrice && (
          <button type="button" onClick={() => setPriceOpen(true)} data-testid="mobile-bottom-price" className={itemCls(false)}>
            <span className="flex items-center justify-center w-8 h-8 rounded-full transition-transform active:scale-90">
              <ScanSearch className="w-5 h-5" />
            </span>
            Precio
          </button>
        )}
      </nav>
      {showPrice && <PriceCheckDialog open={priceOpen} onOpenChange={setPriceOpen} boxId={boxId} />}
    </>
  );
};
